<template>
  <div>
    <div class="collapsed-text align-measureText">MEASURE</div>
    <!-- REFACTOR SUGGESTION: showMeasuringTool will always be false if this icon renders - thus giving it the collapse-gray class, and never the collapsed-white class -->
    <fa
      v-if="!showMeasuringTool"
      :icon="['fas', 'ruler']"
      size="2x"
      :class="
        'collapsed-symbol ' + 'collapsed-gray'
      "
    />
    <span
      v-if="measure && showMeasuringTool"
      class="collapsed-text textAtBottom"
    >
      <strong class="text-wrap">{{ measurement[0] }}</strong>
      <br>
      <strong class="text-wrap">{{ measurement[1] }}</strong>
      <br>
      <strong class="clickToStop">CLICK TO STOP</strong>
    </span>
  </div>
</template>

<script>
import CircleStyle from 'ol/style/Circle'
import Draw from 'ol/interaction/Draw'
import Fill from 'ol/style/Fill'
import LineString from 'ol/geom/LineString'
import Polygon from 'ol/geom/Polygon'
import Stroke from 'ol/style/Stroke'
import Style from 'ol/style/Style'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import {getLength, getArea, getDistance} from 'ol/sphere'

import {
  get as projGet,
  fromLonLat,
  toLonLat,
  transform,
  transformExtent
} from 'ol/proj'

export default {
  name: 'MMP_MeasuringTool',
  props: ['map', 'drt', 'measureTriggerProp', 'showMeasuringTool'],
  data() {
    return {
      measurement: ['0', 'm'],
      measure: false,
      usingMeasureTool: false, // not used
      draw: null // REFACTOR -- WEBGIS-2586 -- added this variable. Used in the code, but never declared
    }
  },
  methods: {
    addInteraction() {
      var sketch
      var source = new VectorSource()
      var vector = new VectorLayer({
        source: source,
        zIndex: 200,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: '#ffcc33',
            width: 2
          }),
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({
              color: '#ffcc33'
            })
          })
        })
      })
      var type = 'LineString'
      this.draw = new Draw({
        source: source,
        type: type,
        style: new Style({
          fill: new Fill({
            color: 'rgba(255, 2, 2, 0.2)'
          }),
          stroke: new Stroke({
            color: 'rgba(255, 2, 2, 0.5)',
            lineDash: [10, 10],
            width: 2
          }),
          image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
              color: 'rgba(255, 2, 2, 0.7)'
            }),
            fill: new Fill({
              color: 'rgba(255, 2, 2, 0.2)'
            })
          })
        })
      })
      this.map.addInteraction(this.draw)
      const self = this
      this.draw.on('drawstart', function (evt) {
        // Set sketch
        sketch = evt.feature
        source.clear()
        let listener = sketch.getGeometry().on('change', function (evt) {
          var geom = evt.target
          var output
          if (geom instanceof Polygon) {
            output = self.formatArea(geom) // REFACTOR SUGGESTION -- formatArea is not a fn...?
          } else if (geom instanceof LineString) {
            output = self.formatLength(geom)
          }

          // output[0] is m/km, output[1] is ft/mi
          self.measurement = output[0].split(' ')
        })
      })

      this.draw.on('drawend', function () {
        sketch = null
      })
    },
    booleanBtnClass(btn) {
      return btn
        ? 'primary'
        : this.drt
        ? 'black-transparent btn-dark'
        : 'dark btn-sm'
    },
    formatLength(line) {
      const coordinates = line.getCoordinates();
      let totalLength = 0;

      for (let i = 0; i < coordinates.length - 1; i++) {
        const c1 = transform(coordinates[i], 'EPSG:3857', 'EPSG:4326');
        const c2 = transform(coordinates[i + 1], 'EPSG:3857', 'EPSG:4326');
        totalLength += getDistance(c1, c2);
      }

      var length = getLength(line)
      var output
      var meters
      var feet
      if (length > 100) {
        meters = `${Math.round((length / 1000) * 100) / 100} km`
        feet = `${Math.round((length / 1609.344) * 100) / 100} miles`
      } else {
        meters = `${Math.round(length * 100) / 100} m`
        feet = `${Math.round(length * 3.281 * 100) / 100} feet`
      }
      output = [meters, feet]
      return output
    },
    toggleMeasure() {
      this.measure = !this.measure
      this.$emit('toggleMeasuringTool')
      if (this.measure) {
        this.addInteraction()
      } else {
        this.map.removeInteraction(this.draw)
        this.measurement = ['0', 'm']
      }
    },
    formatArea(polygon) {
      const area = getArea(polygon) //distance between the points (in meters).
      let output
      if (area > 10000) {
        output = Math.round((area / 1000) * 100) / 100
      } else {
        output = Math.round((area / 1000) * 100) / 100
      }
      return output * 0.621371 // convert to miles
    }
  },
  watch: {
    measureTriggerProp: function (newValue, oldValue) {
      if (newValue) {
        this.toggleMeasure()
        this.$emit('resetToggleMeasureProp')
      }
    }
  }
}
</script>
